// import CloseIcon from "@mui/icons-material/Close";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import DeleteIcon from "@mui/icons-material/Delete";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import {
//   Box,
//   Button,
//   Card,
//   CardActions,
//   CardContent,
//   CircularProgress,
//   Divider,
//   Grid,
//   IconButton,
//   MenuItem,
//   Modal,
//   Paper,
//   Select,
//   Stack,
//   styled,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   Typography,
//   useMediaQuery,
// } from "@mui/material";
// import imageCompression from "browser-image-compression";
// import React, { ChangeEvent, useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { brandColors } from "../../App";
// import {
//   addProduct,
//   deleteProduct,
//   fetchProductList,
//   updateProduct,
// } from "../../services/inventoryService";
// import { RootState } from "../../store";
// import { apiRequest } from "../../utils/apiClient";
// import { EditNotifications } from "@mui/icons-material";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "70vw",
//   height: "75vh",
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
//   overflow: "auto",
// };
// const VisuallyHiddenInput = styled("input")({
//   clip: "rect(0 0 0 0)",
//   clipPath: "inset(50%)",
//   height: 1,
//   overflow: "hidden",
//   position: "absolute",
//   bottom: 0,
//   left: 0,
//   whiteSpace: "nowrap",
//   width: 1,
// });

// const Products: React.FC = () => {
//   const [inventory, setInventory] = useState<any[]>([]);
//   const [products, setProducts] = useState<any[]>([]);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [selectedProducts, setSelectedProducts] = useState<any>();
//   const [expandedCategories, setExpandedCategories] = useState<string[]>([]);
//   const [expandedSubCategories, setExpandedSubCategories] = useState<string[]>(
//     [],
//   );
//   const [pagination, setPagination] = useState<any>({ page: 1, limit: 15 });
//   const [totalPages, setTotalPages] = useState<number>(1);
//   const [Search, setSearch] = useState<string>("");
//   const [open, setOpen] = useState(false);
//   const [imageOpen, setImageOpen] = useState(false);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);
//   const user = useSelector((state: RootState) => state.auth.user);
//   const [uploadedImage, setUploadedImage] = useState<File | null>(null);
//   const token = useSelector((state: RootState) => state.auth.token);
//   const isMobile = useMediaQuery("(max-width:930px)");

//   const handleSubCategoryClick = (subCategory: string) => {
//     setExpandedSubCategories(
//       (prev) =>
//         prev.includes(subCategory)
//           ? prev.filter((c) => c !== subCategory) // collapse
//           : [...prev, subCategory], // expand
//     );
//   };

//   const handleDelete = async (product: any) => {
//     const confirm = window.confirm(
//       "Are you sure you want to delete this product?",
//     );
//     if (!confirm) {
//       return;
//     }
//     try {
//       const data = await deleteProduct(product.product_id); // Fetch the inventory data from an API
//       if (data) {
//         getInventoryData();
//         alert("User deleted successfully");
//         setProducts((prev) =>
//           prev.filter((p) => p.product_id !== data.product_id),
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching inventory:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch inventory data when the component mounts
//   const restructureData = (data: any) => {
//     const result: any = [];

//     data.forEach((item: any) => {
//       const { category, sub_category, ...productDetails } = item;

//       // Find or create category group
//       let categoryGroup = result.find((c: any) => c.category === category);
//       if (!categoryGroup) {
//         categoryGroup = { category, subcategories: [] };
//         result.push(categoryGroup);
//       }

//       // Find or create subcategory group
//       let subCategoryGroup = categoryGroup.subcategories.find(
//         (s: any) => s.sub_category === sub_category,
//       );
//       if (!subCategoryGroup) {
//         subCategoryGroup = { sub_category, products: [] };
//         categoryGroup.subcategories.push(subCategoryGroup);
//       }

//       // Push product to subcategory
//       subCategoryGroup.products.push({
//         ...productDetails,
//         category,
//         sub_category,
//       });
//     });

//     return result;
//   };

//   const getInventoryData = async () => {
//     try {
//       const data = await fetchProductList(Search); // Fetch the inventory data from an API
//       setInventory(data);
//       setProducts(restructureData(data));
//     } catch (error) {
//       console.error("Error fetching inventory:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     // getWarehose();
//     getInventoryData();
//   }, []);
//   const handleEdit = (product: any) => {
//     setSelectedProducts(product);
//     handleOpen();
//   };

//   const handleOpenModal = async () => {
//     setSelectedProducts({});
//     handleOpen();
//   };

//   // const handleFileUpload = async (
//   //   e: ChangeEvent<HTMLInputElement>,
//   //   product: any
//   // ) => {
//   //   const files = e.target.files;
//   //   if (!files || files.length === 0) return;

//   //   const file = files[0];

//   //   const validTypes = ["image/jpeg", "image/jpg", "image/png"];
//   //   const maxSizeMB = 1;

//   //   if (!validTypes.includes(file.type)) {
//   //     alert(`Invalid file type`);
//   //     return;
//   //   }

//   //   if (file.size > maxSizeMB * 1024 * 1024) {
//   //     alert(`File too large`);
//   //     return;
//   //   }

//   //   // 🔥 Store file locally, do NOT upload now
//   //   setUploadedImage(file);
//   //   if (file) {
//   //     const formData = new FormData();
//   //     formData.append("file", file);
//   //     formData.append("product_id", product.product_id);
//   //     const uploadResponse = await fetch("/api/products/uploadImage", {
//   //       method: "POST",
//   //       body: formData,
//   //       headers: {
//   //         Bearer: `Bearer ${token}`,
//   //       },
//   //     });

//   //     const imgData = await uploadResponse;
//   //     if (imgData) {
//   //       alert("Image uploaded successfully");
//   //     }
//   //   }
//   // };

//   const handleFileUpload = async (
//     e: ChangeEvent<HTMLInputElement>,
//     product: any,
//   ) => {
//     const files = e.target.files;
//     if (!files?.length) return;

//     const file = files[0];

//     const validTypes = ["image/jpeg", "image/png", "image/webp"];
//     if (!validTypes.includes(file.type)) {
//       alert("Invalid file type");
//       return;
//     }

//     // 🔥 compress before upload (huge UX improvement)
//     const compressedFile = await imageCompression(file, {
//       maxSizeMB: 1,
//       maxWidthOrHeight: 800,
//       useWebWorker: true,
//     });

//     const formData = new FormData();
//     formData.append("file", compressedFile);
//     formData.append("product_id", product.product_id);

//     const res = await fetch("/api/products/uploadImage", {
//       method: "POST",
//       body: formData,
//       headers: {
//         Authorization: `Bearer ${token}`, // ✅ FIXED
//       },
//     });

//     const data = await res.json(); // ✅ FIXED

//     if (!res.ok) {
//       alert(data.message || "Upload failed");
//       return;
//     }

//     alert("Image uploaded successfully");
//   };

//   // -----------------------------
//   // Mobile component
//   // -----------------------------
//   const MobileRow = ({ product }: { product: any }) => {
//     const DetailItem = ({
//       label,
//       value,
//     }: {
//       label: string;
//       value: React.ReactNode;
//     }) => (
//       <Box>
//         <Typography
//           variant="caption"
//           color="text.secondary"
//           sx={{ display: "block", width: "100%" }}
//         >
//           {label}
//         </Typography>

//         <Typography
//           variant="body2"
//           fontWeight={500}
//           sx={{ overflowWrap: "anywhere" }}
//         >
//           {value ?? "-"}
//         </Typography>
//       </Box>
//     );

//     return (
//       <Card
//         variant="outlined"
//         sx={{
//           borderRadius: 2,
//           mb: 1.5,
//           width: "100%",
//         }}
//       >
//         <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
//           {/* Top row */}
//           <Stack
//             direction="row"
//             alignItems="flex-start"
//             justifyContent="space-between"
//             spacing={1}
//           >
//             <Box sx={{ minWidth: 0, flex: 1 }}>
//               <Typography
//                 variant="subtitle1"
//                 fontWeight={700}
//                 sx={{ overflowWrap: "anywhere" }}
//               >
//                 {product.name || "Unnamed product"}
//               </Typography>

//               <Typography
//                 variant="body2"
//                 color="text.secondary"
//                 sx={{
//                   mt: 0.25,
//                   overflowWrap: "anywhere",
//                 }}
//               >
//                 {product.description || "No description"}
//               </Typography>
//             </Box>

//             <Stack direction="row" spacing={0.5}>
//               <IconButton
//                 size="small"
//                 aria-label="View product"
//                 onClick={() => handleImageClick(product)}
//               >
//                 <VisibilityIcon fontSize="small" />
//               </IconButton>

//               <IconButton
//                 component="label"
//                 size="small"
//                 color="success"
//                 aria-label="Upload product image"
//               >
//                 <CloudUploadIcon fontSize="small" />

//                 <VisuallyHiddenInput
//                   type="file"
//                   multiple
//                   onChange={(event) => handleFileUpload(event, product)}
//                 />
//               </IconButton>
//             </Stack>
//           </Stack>

//           <Divider sx={{ my: 1.25 }} />

//           {/* Details */}
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
//               gap: 1.25,
//             }}
//           >
//             <DetailItem label="Supplier" value={product.supplier} />
//             <DetailItem label="Unit" value={product.unit} />
//             <DetailItem label="Cost" value={product.cost} />
//             <DetailItem label="Pre-pack" value={product.packed} />
//           </Box>
//         </CardContent>

//         <Divider />

//         <CardActions
//           sx={{
//             px: 1.5,
//             py: 1,
//             justifyContent: "flex-end",
//           }}
//         >
//           <Button
//             variant="outlined"
//             size="small"
//             startIcon={<EditNotifications />}
//             onClick={() => handleEdit(product)}
//           >
//             Edit
//           </Button>

//           <Button
//             variant="outlined"
//             color="error"
//             size="small"
//             startIcon={<DeleteIcon />}
//             onClick={() => handleDelete(product)}
//             disabled={user?.role !== "SuperAdmin"}
//           >
//             Delete
//           </Button>
//         </CardActions>
//       </Card>
//     );
//   };
//   const handleSaveProduct = async (product: any) => {
//     try {
//       let savedProduct: any = null;

//       // -----------------------------
//       // CREATE NEW PRODUCT
//       // -----------------------------
//       if (!product.product_id) {
//         if (
//           !product.name ||
//           !product.description ||
//           !product.cost ||
//           !product.msrp ||
//           !product.category ||
//           !product.sub_category ||
//           !product.packed ||
//           !product.unit
//         ) {
//           alert("Please fill in all the required fields");
//           return;
//         }
//         const response = await addProduct(product);
//         if (response.status !== 200) {
//           alert("Error adding product");
//           return;
//         }

//         savedProduct = response.data; // includes product_id
//         setProducts((prev) => [...prev, savedProduct]);
//       }
//       // -----------------------------
//       // UPDATE EXISTING PRODUCT
//       // -----------------------------
//       else {
//         const response = await updateProduct(product);
//         if (response.status !== 200) {
//           alert("Error updating product");
//           return;
//         }

//         savedProduct = response.data[0];
//         // set the updated product in the inventory
//         setInventory((prev) =>
//           prev.map((item) =>
//             item.product_id === savedProduct.product_id
//               ? { ...savedProduct }
//               : item,
//           ),
//         );

//         // update UI
//         setProducts(
//           restructureData(
//             inventory.map((item) =>
//               item.product_id === savedProduct.product_id
//                 ? { ...savedProduct }
//                 : item,
//             ),
//           ),
//         );
//       }

//       // -----------------------------
//       // UPLOAD IMAGE IF AVAILABLE
//       // -----------------------------
//       if (uploadedImage) {
//         const formData = new FormData();
//         formData.append("file", uploadedImage);
//         formData.append("product_id", savedProduct.product_id);

//         const uploadResponse = await apiRequest(
//           "/api/products/create",
//           "POST",
//           {
//             body: formData,
//           },
//         );

//         const imgData = await uploadResponse;
//         if (imgData) {
//           alert("Image uploaded successfully");
//           // update UI
//           setProducts((prev) =>
//             prev.map((item) =>
//               item.product_id === savedProduct.product_id
//                 ? { ...item, image: imgData.data.image }
//                 : item,
//             ),
//           );
//         }
//       }

//       alert(
//         product.product_id
//           ? "Product updated successfully"
//           : "Product added successfully",
//       );

//       setUploadedImage(null); // reset
//       setSelectedProducts(null);
//       handleClose();
//     } catch (error) {
//       console.error("Save product error:", error);
//       alert("Something went wrong.");
//     }
//   };
//   const handleRowClick = (category: string) => {
//     setExpandedCategories(
//       (prev) =>
//         prev.includes(category)
//           ? prev.filter((c) => c !== category) // collapse
//           : [...prev, category], // expand
//     );
//   };

//   const handleImageClick = (product: any) => {
//     setSelectedProducts(product);
//     setImageOpen(true);
//   };

//   const handlePageChange = (operation: "next" | "prev") => {
//     if (
//       (operation === "next" && pagination.page < totalPages) ||
//       (operation === "prev" && pagination.page > 1)
//     ) {
//       const delta = operation === "next" ? 1 : -1;
//       setPagination({ ...pagination, page: pagination.page + delta });
//     }
//   };
//   const handleSearch = () => {
//     getInventoryData();
//   };

//   return (
//     <>
//       <Box sx={{ padding: 1 }}>
//         {loading ? (
//           <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
//         ) : (
//           <>
//             <TableContainer component={Paper} sx={{ height: "80vh" }}>
//               <Table
//                 stickyHeader
//                 size="small"
//                 sx={{
//                   // minWidth: 650,
//                   border: "1px solid #E3E6E1",
//                   borderRadius: "8px",
//                   overflow: "hidden",
//                 }}
//               >
//                 {/* ================= TABLE HEADER (LEVEL 1) ================= */}
//                 <TableHead>
//                   <TableRow>
//                     <TableCell
//                       align="right"
//                       sx={{
//                         width: "50px",
//                         backgroundColor: brandColors.header,
//                         color: "#FFFFFF",
//                         fontWeight: 600,
//                         fontSize: "17px",
//                       }}
//                     >
//                       No
//                     </TableCell>
//                     <TableCell
//                       align="center"
//                       sx={{
//                         backgroundColor: brandColors.header,
//                         color: "#FFFFFF",
//                         fontWeight: 600,
//                         fontSize: "17px",
//                         textAlign: "left",
//                         pl: "20%",
//                       }}
//                     >
//                       Category
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {products.map((item: any, index: number) => (
//                     <React.Fragment key={item.category}>
//                       {/* ================= CATEGORY ROW ================= */}
//                       <TableRow
//                         hover
//                         onClick={() => handleRowClick(item.category)}
//                         sx={{
//                           cursor: "pointer",
//                           "&:hover": { backgroundColor: "#EEF4EA" },
//                         }}
//                       >
//                         <TableCell
//                           align="right"
//                           sx={{
//                             fontWeight: 600,
//                             fontSize: "15px",
//                             color: "#1F1F1F",
//                           }}
//                         >
//                           {index + 1}
//                         </TableCell>
//                         <TableCell
//                           align="center"
//                           sx={{
//                             fontWeight: 600,
//                             fontSize: "15px",
//                             color: "#1F1F1F",
//                             textAlign: "left",
//                             pl: "20%",
//                           }}
//                         >
//                           {item.category}
//                         </TableCell>
//                       </TableRow>

//                       {/* ================= EXPANDED CATEGORY ================= */}
//                       {expandedCategories.includes(item.category) && (
//                         <TableRow sx={{ backgroundColor: "#f7fdf2ff" }}>
//                           <TableCell colSpan={2}>
//                             {item?.subcategories?.map((sub: any) => (
//                               <Box key={sub.sub_category}>
//                                 {/* ================= SUB-CATEGORY HEADER ================= */}
//                                 <Typography
//                                   onClick={() =>
//                                     handleSubCategoryClick(sub.sub_category)
//                                   }
//                                   sx={{
//                                     fontSize: "13px",
//                                     fontWeight: 600,
//                                     color: "#2F6B2F",
//                                     cursor: "pointer",
//                                     py: 1,
//                                     borderBottom: "1px solid #D1D1D1",
//                                     "&:hover": { backgroundColor: "#E3E6E1" },
//                                     textAlign: "left",
//                                     pl: "30%",
//                                   }}
//                                 >
//                                   {sub.sub_category}
//                                 </Typography>

//                                 {/* ================= PRODUCT TABLE (LEVEL 3) ================= */}
//                                 {expandedSubCategories.includes(
//                                   sub.sub_category,
//                                 ) &&
//                                   (isMobile ? (
//                                     <Box
//                                       sx={{
//                                         display: { xs: "block", md: "none" },
//                                       }}
//                                     >
//                                       {sub.products.map((prod: any) => (
//                                         <MobileRow
//                                           key={prod.product_id}
//                                           product={prod}
//                                         />
//                                       ))}
//                                     </Box>
//                                   ) : (
//                                     <Box
//                                       sx={{
//                                         mt: 1,
//                                         border: "1px solid #E3E6E1",
//                                         borderRadius: "5px",
//                                         overflow: "hidden",
//                                         backgroundColor: "#FFFFFF",
//                                       }}
//                                     >
//                                       <Table
//                                         size="small"
//                                         stickyHeader
//                                         sx={{ border: "1px solid #91a883ff" }}
//                                       >
//                                         <TableHead>
//                                           <TableRow
//                                             sx={{
//                                               backgroundColor:
//                                                 brandColors.header,
//                                             }}
//                                           >
//                                             {[
//                                               "View",
//                                               "Upload",
//                                               "Name",
//                                               "Description",
//                                               // "Category",
//                                               // "Sub Category",
//                                               "Supplier",
//                                               "Cost",
//                                               "PrePack",
//                                               "Unit",
//                                               "Modify",
//                                               "Delete",
//                                             ].map((label) => (
//                                               <TableCell
//                                                 key={label}
//                                                 sx={{
//                                                   backgroundColor:
//                                                     brandColors.header,
//                                                   color: "#FFFFFF",
//                                                   fontWeight: 600,
//                                                   fontSize: "14.5px",
//                                                 }}
//                                               >
//                                                 {label}
//                                               </TableCell>
//                                             ))}
//                                           </TableRow>
//                                         </TableHead>

//                                         <TableBody>
//                                           {sub.products.map((prod: any) => {
//                                             return (
//                                               <TableRow key={prod.product_id}>
//                                                 <TableCell>
//                                                   <VisibilityIcon
//                                                     fontSize="small"
//                                                     sx={{ cursor: "pointer" }}
//                                                     onClick={() =>
//                                                       handleImageClick(prod)
//                                                     }
//                                                   />
//                                                 </TableCell>
//                                                 <TableCell>
//                                                   <Button
//                                                     component="label"
//                                                     role={undefined}
//                                                     variant="text"
//                                                     size="small"
//                                                     tabIndex={-1}
//                                                     startIcon={
//                                                       <CloudUploadIcon />
//                                                     }
//                                                   >
//                                                     <VisuallyHiddenInput
//                                                       sx={{
//                                                         border: "none",
//                                                         borderWidth: "none",
//                                                       }}
//                                                       type="file"
//                                                       onChange={(event) =>
//                                                         handleFileUpload(
//                                                           event,
//                                                           prod,
//                                                         )
//                                                       }
//                                                       multiple
//                                                     />
//                                                   </Button>
//                                                 </TableCell>
//                                                 <TableCell>
//                                                   {prod.name}
//                                                 </TableCell>
//                                                 <TableCell>
//                                                   {prod.description}
//                                                 </TableCell>
//                                                 <TableCell>
//                                                   {prod.supplier}
//                                                 </TableCell>
//                                                 <TableCell>
//                                                   {prod.cost}
//                                                 </TableCell>
//                                                 <TableCell>
//                                                   {prod.packed}
//                                                 </TableCell>
//                                                 <TableCell>
//                                                   {prod.unit}
//                                                 </TableCell>
//                                                 <TableCell>
//                                                   <Button
//                                                     variant="outlined"
//                                                     onClick={() =>
//                                                       handleEdit(prod)
//                                                     }
//                                                     size="small"
//                                                   >
//                                                     Edit
//                                                   </Button>
//                                                 </TableCell>
//                                                 <TableCell>
//                                                   <Button
//                                                     variant="outlined"
//                                                     color="error"
//                                                     onClick={() =>
//                                                       handleDelete(prod)
//                                                     }
//                                                     disabled={
//                                                       user?.role !==
//                                                       "SuperAdmin"
//                                                     }
//                                                     size="small"
//                                                   >
//                                                     <DeleteIcon />
//                                                   </Button>
//                                                 </TableCell>
//                                               </TableRow>
//                                             );
//                                           })}
//                                         </TableBody>
//                                       </Table>
//                                     </Box>
//                                   ))}
//                               </Box>
//                             ))}
//                           </TableCell>
//                         </TableRow>
//                       )}
//                     </React.Fragment>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <Box
//               sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                   height: "40px",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <TextField
//                   id="outlined-basic"
//                   label="Search"
//                   variant="outlined"
//                   size="small"
//                   onChange={(e) => setSearch(e.target.value)}
//                 />
//                 <Button variant="contained" onClick={handleSearch}>
//                   Search
//                 </Button>
//               </div>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => handleOpenModal()}
//               >
//                 + Add Product
//               </Button>
//             </Box>
//           </>
//         )}
//       </Box>
//       <Modal
//         open={imageOpen}
//         onClose={() => setImageOpen(false)}
//         aria-labelledby="modal-modal-title"
//         aria-describedby="modal-modal-description"
//       >
//         <Box sx={style}>
//           <img
//             src={`https://order.kalamata.ca/uploads/products/${selectedProducts?.image}`}
//             alt="Product"
//             style={{ width: "100%" }}
//           />
//         </Box>
//       </Modal>
//       <Modal
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="modal-modal-title"
//         aria-describedby="modal-modal-description"
//       >
//         <Box sx={style}>
//           {selectedProducts && (
//             <div
//               style={{
//                 overflow: "auto",
//                 maxHeight: "70vh",
//                 height: "100%",
//                 width: "100%",
//               }}
//             >
//               <Stack direction={"row"} sx={{ justifyContent: "space-between" }}>
//                 <Typography
//                   id="modal-modal-title"
//                   variant="body1"
//                   component="h2"
//                   align="left"
//                   color="textDisabled"
//                 >
//                   Edit Product
//                 </Typography>
//                 <CloseIcon onClick={handleClose} />
//               </Stack>
//               <Grid container spacing={1} justifyContent="center">
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="Product Name"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.name}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         name: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="Description"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.description}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         description: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="Category"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.category}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         category: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="Sub Category"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.sub_category}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         sub_category: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="Supplier"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.supplier}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         supplier: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="Cost"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.cost}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         cost: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="MSRP"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.msrp}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         msrp: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="Prepack"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.packed}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         packed: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="Unit"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.unit}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         unit: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     label="HST"
//                     // size="small"
//                     variant="outlined"
//                     fullWidth
//                     margin="normal"
//                     value={selectedProducts.hst}
//                     onChange={(e) =>
//                       setSelectedProducts({
//                         ...selectedProducts,
//                         hst: e.target.value,
//                       })
//                     }
//                   />
//                 </Grid>
//                 <Grid
//                   size={12}
//                   gap={1}
//                   sx={{
//                     display: "flex",
//                     flexDirection: "row",
//                     // alignItems: "center",
//                     // gap: 5,
//                   }}
//                 >
//                   <Grid size={6}>
//                     <Stack
//                       direction={"row"}
//                       sx={{
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                       }}
//                     >
//                       <Typography>Client Visible</Typography>
//                       <Select
//                         value={selectedProducts.client_visible}
//                         size="small"
//                         label="Client Visible"
//                         onChange={(e) =>
//                           setSelectedProducts({
//                             ...selectedProducts,
//                             client_visible: e.target.value,
//                           })
//                         }
//                       >
//                         <MenuItem value="true">Yes</MenuItem>
//                         <MenuItem value="false">No</MenuItem>
//                       </Select>
//                     </Stack>
//                   </Grid>

//                   <Grid size={6}>
//                     <Stack
//                       direction={"row"}
//                       sx={{
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                       }}
//                     >
//                       <Typography>Store Visible</Typography>
//                       <Select
//                         value={selectedProducts.store_visible}
//                         size="small"
//                         label="Store Visible"
//                         onChange={(e) =>
//                           setSelectedProducts({
//                             ...selectedProducts,
//                             store_visible: e.target.value,
//                           })
//                         }
//                       >
//                         <MenuItem value="true">Yes</MenuItem>
//                         <MenuItem value="false">No</MenuItem>
//                       </Select>
//                     </Stack>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </div>
//           )}
//           <Grid
//             size={12}
//             sx={{ display: "flex", justifyContent: "center", gap: 3 }}
//           >
//             <Button
//               variant="contained"
//               color="primary"
//               sx={{ mt: 2 }}
//               onClick={() => handleSaveProduct(selectedProducts)}
//             >
//               Save
//             </Button>
//             <Button
//               variant="outlined"
//               color="error"
//               sx={{ mt: 2 }}
//               onClick={handleClose}
//             >
//               Cancel
//             </Button>
//           </Grid>
//         </Box>
//       </Modal>
//     </>
//   );
// };

// export default Products;

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import imageCompression from "browser-image-compression";
import React, {
  ChangeEvent,
  KeyboardEvent,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useSelector } from "react-redux";
import { brandColors } from "../../App";
import {
  addProduct,
  deleteProduct,
  fetchProductList,
  updateProduct,
} from "../../services/inventoryService";
import { RootState } from "../../store";
import { apiRequest } from "../../utils/apiClient";

/* ==========================================================================
   TYPES
   ========================================================================== */

interface Product {
  product_id?: string;
  name?: string;
  description?: string;
  category?: string;
  sub_category?: string;
  supplier?: string;
  cost?: number | string;
  msrp?: number | string;
  packed?: number | string;
  unit?: string;
  hst?: number | string;
  client_visible?: boolean | string;
  store_visible?: boolean | string;
  image?: string;

  /**
   * Preserve any additional fields returned by the current API.
   * This prevents accidental loss of backend properties during edits.
   */
  [key: string]: unknown;
}

interface ProductSubcategory {
  sub_category: string;
  products: Product[];
}

interface ProductCategory {
  category: string;
  subcategories: ProductSubcategory[];
}

interface ProductImageProps {
  product: Product;
  size?: number;
  onView: (product: Product) => void;
}

interface MobileProductCardProps {
  product: Product;
  onOpenActions: (
    event: React.MouseEvent<HTMLElement>,
    product: Product,
  ) => void;
  onView: (product: Product) => void;
}

interface DesktopProductTableProps {
  products: Product[];
  onOpenActions: (
    event: React.MouseEvent<HTMLElement>,
    product: Product,
  ) => void;
  onView: (product: Product) => void;
}

/* ==========================================================================
   CONSTANTS AND SHARED HELPERS
   ========================================================================== */

const PRODUCT_IMAGE_BASE_URL = "https://order.kalamata.ca/uploads/products";

const ALL_FILTER_VALUE = "ALL";

/**
 * Visually hides the native input while preserving keyboard and screen-reader
 * accessibility for the upload button.
 */
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

/**
 * Safely converts nullable API values into readable UI text.
 */
const displayValue = (value: unknown, fallback = "—"): string => {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  return String(value);
};

/**
 * Converts the flat API response into the hierarchy used by the UI:
 * Category -> Subcategory -> Products.
 *
 * Map is used instead of repeated Array.find calls, which keeps grouping fast
 * as the product list grows.
 */
const groupProducts = (data: Product[]): ProductCategory[] => {
  const categoryMap = new Map<string, Map<string, Product[]>>();

  data.forEach((product) => {
    const category = displayValue(product.category, "Uncategorized");
    const subcategory = displayValue(product.sub_category, "General");

    if (!categoryMap.has(category)) {
      categoryMap.set(category, new Map<string, Product[]>());
    }

    const subcategoryMap = categoryMap.get(category)!;

    if (!subcategoryMap.has(subcategory)) {
      subcategoryMap.set(subcategory, []);
    }

    subcategoryMap.get(subcategory)!.push(product);
  });

  return Array.from(categoryMap.entries()).map(
    ([category, subcategoryMap]) => ({
      category,
      subcategories: Array.from(subcategoryMap.entries()).map(
        ([sub_category, products]) => ({
          sub_category,
          products,
        }),
      ),
    }),
  );
};

/**
 * Returns the image filename from the different response structures currently
 * used by the backend endpoints.
 */
const extractImageName = (responseData: any): string | undefined =>
  responseData?.image ??
  responseData?.data?.image ??
  responseData?.product?.image ??
  responseData?.data?.product?.image;

/* ==========================================================================
   MEMOIZED PRESENTATIONAL COMPONENTS
   ========================================================================== */

/**
 * Lazy-loaded product thumbnail.
 *
 * This component is outside Products and wrapped with React.memo so opening a
 * dialog or menu does not force every product image to render again.
 */
const ProductImage = memo(
  ({ product, size = 48, onView }: ProductImageProps) => {
    if (!product.image) {
      return (
        <Box
          sx={{
            width: size,
            height: size,
            display: "grid",
            placeItems: "center",
            bgcolor: "grey.100",
            color: "text.secondary",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1.5,
            flexShrink: 0,
          }}
        >
          <ImageNotSupportedOutlinedIcon fontSize="small" />
        </Box>
      );
    }

    return (
      <Tooltip title="View product image">
        <Box
          component="img"
          src={`${PRODUCT_IMAGE_BASE_URL}/${product.image}`}
          alt={product.name || "Product"}
          loading="lazy"
          decoding="async"
          onClick={() => onView(product)}
          sx={{
            width: size,
            height: size,
            objectFit: "cover",
            borderRadius: 1.5,
            border: "1px solid",
            borderColor: "divider",
            cursor: "pointer",
            flexShrink: 0,
          }}
        />
      </Tooltip>
    );
  },
);

ProductImage.displayName = "ProductImage";

/**
 * Compact card used on mobile devices.
 */
const MobileProductCard = memo(
  ({ product, onOpenActions, onView }: MobileProductCardProps) => (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2.5,
        boxShadow: "0 3px 12px rgba(20, 60, 25, 0.06)",
      }}
    >
      <CardContent sx={{ p: 1.75, "&:last-child": { pb: 1.75 } }}>
        <Stack direction="row" spacing={1.5} alignItems="flex-start">
          <ProductImage product={product} size={58} onView={onView} />

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              sx={{ overflowWrap: "anywhere" }}
            >
              {displayValue(product.name, "Unnamed product")}
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 0.25,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {displayValue(product.description, "No description")}
            </Typography>
          </Box>

          <Tooltip title="Product actions">
            <IconButton
              size="small"
              aria-label={`Actions for ${product.name || "product"}`}
              onClick={(event) => onOpenActions(event, product)}
            >
              <MoreVertIcon />
            </IconButton>
          </Tooltip>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 1.25,
          }}
        >
          {[
            ["Supplier", product.supplier],
            ["Cost", product.cost],
            ["Pre-pack", product.packed],
            ["Unit", product.unit],
          ].map(([label, value]) => (
            <Box key={String(label)}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block" }}
              >
                {label}
              </Typography>

              <Typography
                variant="body2"
                fontWeight={600}
                sx={{ overflowWrap: "anywhere" }}
              >
                {displayValue(value)}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  ),
);

MobileProductCard.displayName = "MobileProductCard";

/**
 * Streamlined desktop table.
 *
 * Name and description are combined, while all row operations use one shared
 * actions menu owned by the parent component.
 */
const DesktopProductTable = memo(
  ({ products, onOpenActions, onView }: DesktopProductTableProps) => (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: "none",
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            {[
              "Image",
              "Product",
              "Supplier",
              "Cost",
              "Pre-pack",
              "Unit",
              "Actions",
            ].map((label) => (
              <TableCell
                key={label}
                align={label === "Actions" ? "right" : "left"}
                sx={{
                  bgcolor: brandColors.header,
                  color: "common.white",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {products.map((product) => (
            <TableRow
              hover
              key={product.product_id || `${product.name}-${product.supplier}`}
              sx={{
                "&:last-child td": { borderBottom: 0 },
                "& td": { py: 1.1 },
              }}
            >
              <TableCell sx={{ width: 72 }}>
                <ProductImage product={product} onView={onView} />
              </TableCell>

              <TableCell sx={{ minWidth: 260 }}>
                <Typography variant="body2" fontWeight={700}>
                  {displayValue(product.name, "Unnamed product")}
                </Typography>

                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    display: "block",
                    maxWidth: 430,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {displayValue(product.description, "No description")}
                </Typography>
              </TableCell>

              <TableCell>{displayValue(product.supplier)}</TableCell>
              <TableCell>{displayValue(product.cost)}</TableCell>
              <TableCell>{displayValue(product.packed)}</TableCell>

              <TableCell>
                <Chip
                  label={displayValue(product.unit)}
                  size="small"
                  variant="outlined"
                />
              </TableCell>

              <TableCell align="right">
                <Tooltip title="Product actions">
                  <IconButton
                    size="small"
                    aria-label={`Actions for ${product.name || "product"}`}
                    onClick={(event) => onOpenActions(event, product)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ),
);

DesktopProductTable.displayName = "DesktopProductTable";

/* ==========================================================================
   MAIN COMPONENT
   ========================================================================== */

const Products: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const user = useSelector((state: RootState) => state.auth.user);
  const token = useSelector((state: RootState) => state.auth.token);

  /**
   * Keep one source of truth.
   * Grouped categories are derived with useMemo instead of duplicated in state.
   */
  const [inventory, setInventory] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [uploadingProductId, setUploadingProductId] = useState<string | null>(
    null,
  );

  const [search, setSearch] = useState<string>("");
  const [selectedSupplier, setSelectedSupplier] =
    useState<string>(ALL_FILTER_VALUE);
  const [selectedCategory, setSelectedCategory] =
    useState<string>(ALL_FILTER_VALUE);

  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [uploadedImage, setUploadedImage] = useState<File | null>(null);

  const [productDialogOpen, setProductDialogOpen] = useState(false);
  const [imageDialogOpen, setImageDialogOpen] = useState(false);

  /**
   * One shared menu is used for the entire page rather than rendering one Menu
   * for every product row.
   */
  const [actionMenuAnchor, setActionMenuAnchor] = useState<HTMLElement | null>(
    null,
  );
  const [actionProduct, setActionProduct] = useState<Product | null>(null);

  /**
   * Normalizes text for case-insensitive comparisons and duplicate removal.
   */
  const normalizeFilterValue = (value: unknown): string =>
    displayValue(value, "").trim().toLocaleUpperCase();

  /**
   * Creates unique supplier options regardless of casing.
   *
   * Examples:
   * KALAMATA, Kalamata, kalaMata -> KALAMATA
   */
  const supplierOptions = useMemo(
    () =>
      Array.from(
        new Set(
          inventory
            .map((product) => normalizeFilterValue(product.supplier))
            .filter(Boolean),
        ),
      ).sort((a, b) => a.localeCompare(b)),
    [inventory],
  );

  const categoryOptions = useMemo(
    () =>
      Array.from(
        new Set(
          inventory
            .map((product) => displayValue(product.category, ""))
            .filter(Boolean),
        ),
      ).sort((a, b) => a.localeCompare(b)),
    [inventory],
  );

  /**
   * Filters products without case-sensitive comparisons.
   */
  const filteredInventory = useMemo(
    () =>
      inventory.filter((product) => {
        const normalizedSupplier = normalizeFilterValue(product.supplier);
        const normalizedCategory = normalizeFilterValue(product.category);

        const supplierMatches =
          selectedSupplier === ALL_FILTER_VALUE ||
          normalizedSupplier === normalizeFilterValue(selectedSupplier);

        const categoryMatches =
          selectedCategory === ALL_FILTER_VALUE ||
          normalizedCategory === normalizeFilterValue(selectedCategory);

        return supplierMatches && categoryMatches;
      }),
    [inventory, selectedSupplier, selectedCategory],
  );

  /**
   * Expensive hierarchical grouping is memoized.
   */
  const groupedProducts = useMemo(
    () => groupProducts(filteredInventory),
    [filteredInventory],
  );

  /**
   * Loads products from the existing service.
   *
   * Full refetches are now limited to initial load and explicit searches.
   * Create, update, delete, and image upload update local state directly.
   */
  const getInventoryData = useCallback(async (): Promise<void> => {
    setLoading(true);

    try {
      const data = (await fetchProductList(search)) as Product[];
      setInventory(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching inventory:", error);
      alert("Unable to load products.");
    } finally {
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    void getInventoryData();
    // Initial load only. Search is intentionally triggered by the user.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Opens the add-product dialog with safe default visibility values.
   */
  const handleAddProduct = useCallback((): void => {
    setUploadedImage(null);
    setSelectedProduct({
      client_visible: "true",
      store_visible: "true",
    });
    setProductDialogOpen(true);
  }, []);

  /**
   * Opens the edit dialog without mutating the table row object.
   */
  const handleEdit = useCallback((product: Product): void => {
    setUploadedImage(null);
    setSelectedProduct({ ...product });
    setProductDialogOpen(true);
  }, []);

  /**
   * Opens the image preview.
   */
  const handleImageClick = useCallback((product: Product): void => {
    setSelectedProduct(product);
    setImageDialogOpen(true);
  }, []);

  /**
   * Closes and resets the product dialog.
   */
  const handleCloseProductDialog = useCallback((): void => {
    if (saving) {
      return;
    }

    setProductDialogOpen(false);
    setSelectedProduct(null);
    setUploadedImage(null);
  }, [saving]);

  /**
   * Opens the shared row-actions menu for the selected product.
   */
  const handleOpenActions = useCallback(
    (event: React.MouseEvent<HTMLElement>, product: Product): void => {
      setActionMenuAnchor(event.currentTarget);
      setActionProduct(product);
    },
    [],
  );

  /**
   * Closes the shared actions menu.
   */
  const handleCloseActions = useCallback((): void => {
    setActionMenuAnchor(null);
    setActionProduct(null);
  }, []);

  /**
   * Updates one form field while preserving all other product values.
   */
  const updateSelectedProduct = useCallback(
    (field: keyof Product, value: unknown): void => {
      setSelectedProduct((currentProduct) =>
        currentProduct
          ? {
              ...currentProduct,
              [field]: value,
            }
          : currentProduct,
      );
    },
    [],
  );

  /**
   * Deletes one product and removes it locally.
   * This avoids downloading and rebuilding the entire product list.
   */
  const handleDelete = useCallback(async (product: Product): Promise<void> => {
    if (!product.product_id) {
      return;
    }

    const confirmed = window.confirm(
      `Are you sure you want to delete "${product.name || "this product"}"?`,
    );

    if (!confirmed) {
      return;
    }

    try {
      await deleteProduct(product.product_id);

      setInventory((currentInventory) =>
        currentInventory.filter(
          (item) => item.product_id !== product.product_id,
        ),
      );

      alert("Product deleted successfully");
    } catch (error) {
      console.error("Error deleting product:", error);
      alert("Unable to delete product.");
    }
  }, []);

  /**
   * Uploads an image for an existing product.
   *
   * The image is compressed in a web worker, and only the affected product is
   * updated locally when the backend returns the new image filename.
   */
  const handleFileUpload = useCallback(
    async (
      event: ChangeEvent<HTMLInputElement>,
      product: Product,
    ): Promise<void> => {
      const file = event.target.files?.[0];

      if (!file || !product.product_id) {
        return;
      }

      const validTypes = ["image/jpeg", "image/png", "image/webp"];

      if (!validTypes.includes(file.type)) {
        alert("Please select a JPEG, PNG, or WebP image.");
        event.target.value = "";
        return;
      }

      setUploadingProductId(product.product_id);

      try {
        const compressedFile = await imageCompression(file, {
          maxSizeMB: 1,
          maxWidthOrHeight: 800,
          useWebWorker: true,
        });

        const formData = new FormData();
        formData.append("file", compressedFile);
        formData.append("product_id", product.product_id);

        const response = await fetch("/api/products/uploadImage", {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const responseData = await response.json();

        if (!response.ok) {
          alert(responseData.message || "Upload failed");
          return;
        }

        const imageName = extractImageName(responseData);

        if (imageName) {
          setInventory((currentInventory) =>
            currentInventory.map((item) =>
              item.product_id === product.product_id
                ? { ...item, image: imageName }
                : item,
            ),
          );
        }

        alert("Image uploaded successfully");
      } catch (error) {
        console.error("Image upload error:", error);
        alert("Unable to upload the image.");
      } finally {
        setUploadingProductId(null);
        event.target.value = "";
      }
    },
    [token],
  );

  /**
   * Stores an image for a new product. It is uploaded after the product is
   * created and a product_id is available.
   */
  const handleNewProductImageSelection = useCallback(
    (event: ChangeEvent<HTMLInputElement>): void => {
      const file = event.target.files?.[0];

      if (!file) {
        return;
      }

      const validTypes = ["image/jpeg", "image/png", "image/webp"];

      if (!validTypes.includes(file.type)) {
        alert("Please select a JPEG, PNG, or WebP image.");
        event.target.value = "";
        return;
      }

      setUploadedImage(file);
    },
    [],
  );

  /**
   * Creates or updates a product while preserving the original endpoints and
   * payload behavior.
   *
   * The affected item is merged into local state instead of refetching all
   * products, which makes save actions noticeably faster.
   */
  const handleSaveProduct = useCallback(
    async (product: Product): Promise<void> => {
      if (saving) {
        return;
      }

      setSaving(true);

      try {
        let savedProduct: Product | null = null;

        if (!product.product_id) {
          const requiredValues = [
            product.name,
            product.description,
            product.cost,
            product.msrp,
            product.category,
            product.sub_category,
            product.packed,
            product.unit,
          ];

          if (
            requiredValues.some(
              (value) => value === "" || value === null || value === undefined,
            )
          ) {
            alert("Please fill in all required fields.");
            return;
          }

          const response = await addProduct(product);

          if (response.status !== 200) {
            alert("Error adding product");
            return;
          }

          savedProduct = response.data as Product;
        } else {
          const response = await updateProduct(product);

          if (response.status !== 200) {
            if (response.status === 409) {
              alert(response.message);
              return;
            }
            alert("Error updating product");
            return;
          }

          savedProduct = (response.data?.[0] ?? response.data) as Product;
        }

        if (!savedProduct) {
          alert("The server did not return the saved product.");
          return;
        }

        /**
         * Upload the optional image after create/update so product_id exists.
         */
        if (uploadedImage && savedProduct.product_id) {
          const compressedImage = await imageCompression(uploadedImage, {
            maxSizeMB: 1,
            maxWidthOrHeight: 800,
            useWebWorker: true,
          });

          const formData = new FormData();
          formData.append("file", compressedImage);
          formData.append("product_id", savedProduct.product_id);

          const imageResponse = await apiRequest(
            "/api/products/create",
            "POST",
            {
              body: formData,
            },
          );

          const uploadedImageName = extractImageName(imageResponse);

          if (uploadedImageName) {
            savedProduct = {
              ...savedProduct,
              image: uploadedImageName,
            };
          }
        }

        if (product.product_id) {
          setInventory((currentInventory) =>
            currentInventory.map((item) =>
              item.product_id === savedProduct!.product_id
                ? { ...item, ...savedProduct }
                : item,
            ),
          );
        } else {
          setInventory((currentInventory) => [
            ...currentInventory,
            savedProduct!,
          ]);
        }

        alert(
          product.product_id
            ? "Product updated successfully"
            : "Product added successfully",
        );

        setProductDialogOpen(false);
        setSelectedProduct(null);
        setUploadedImage(null);
      } catch (error: any) {
        console.error("Save product error:", error.message);

        alert(
          error?.message
            ? error.message
            : "Something went wrong while saving the product.",
        );
      } finally {
        setSaving(false);
      }
    },
    [saving, uploadedImage],
  );

  /**
   * Runs a server search only when the user submits it.
   */
  const handleSearch = useCallback((): void => {
    void getInventoryData();
  }, [getInventoryData]);

  const handleSearchKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>): void => {
      if (event.key === "Enter") {
        handleSearch();
      }
    },
    [handleSearch],
  );

  const handleSupplierChange = useCallback(
    (event: SelectChangeEvent<string>): void => {
      setSelectedSupplier(event.target.value.toUpperCase());
    },
    [],
  );

  const handleCategoryChange = useCallback(
    (event: SelectChangeEvent<string>): void => {
      setSelectedCategory(event.target.value);
    },
    [],
  );

  return (
    <>
      <Box
        sx={{
          p: { xs: 1.5, sm: 2, md: 3 },
          bgcolor: "#F7F9F6",
          minHeight: "100%",
        }}
      >
        {/* ===============================================================
            PAGE HEADER AND FILTERS
        =============================================================== */}
        <Paper
          variant="outlined"
          sx={{
            p: { xs: 1.5, md: 2.5 },
            mb: 2,
            borderRadius: 3,
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", md: "center" }}
            spacing={2}
          >
            <Box>
              <Typography variant="h5" fontWeight={800}>
                Products
              </Typography>

              <Typography variant="body2" color="text.secondary">
                Manage categories, suppliers, pricing, and product images.
              </Typography>
            </Box>

            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAddProduct}
              sx={{ minWidth: { md: 150 }, whiteSpace: "nowrap" }}
            >
              Add Product
            </Button>
          </Stack>

          <Stack
            direction={{ xs: "column", lg: "row" }}
            spacing={1}
            sx={{ mt: 2 }}
          >
            <TextField
              fullWidth
              size="small"
              placeholder="Search products..."
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              onKeyDown={handleSearchKeyDown}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                },
              }}
            />

            <FormControl size="small" sx={{ minWidth: { lg: 180 } }}>
              <InputLabel>Supplier</InputLabel>
              <Select
                label="Supplier"
                value={selectedSupplier}
                onChange={handleSupplierChange}
              >
                <MenuItem value={ALL_FILTER_VALUE}>All suppliers</MenuItem>
                {supplierOptions.map((supplier) => (
                  <MenuItem key={supplier} value={supplier}>
                    {supplier}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: { lg: 180 } }}>
              <InputLabel>Category</InputLabel>
              <Select
                label="Category"
                value={selectedCategory}
                onChange={handleCategoryChange}
              >
                <MenuItem value={ALL_FILTER_VALUE}>All categories</MenuItem>
                {categoryOptions.map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant="contained"
              onClick={handleSearch}
              sx={{ minWidth: 110 }}
            >
              Search
            </Button>
          </Stack>
        </Paper>

        {/* ===============================================================
            CATEGORY AND PRODUCT CONTENT
        =============================================================== */}
        {loading ? (
          <Paper
            variant="outlined"
            sx={{
              minHeight: 320,
              display: "grid",
              placeItems: "center",
              borderRadius: 3,
            }}
          >
            <CircularProgress />
          </Paper>
        ) : groupedProducts.length === 0 ? (
          <Paper
            variant="outlined"
            sx={{ p: 5, textAlign: "center", borderRadius: 3 }}
          >
            <Typography variant="h6" fontWeight={700}>
              No products found
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Try a different search or filter.
            </Typography>
          </Paper>
        ) : (
          <Stack spacing={1.5}>
            {groupedProducts.map((category, categoryIndex) => {
              const categoryProductCount = category.subcategories.reduce(
                (total, subcategory) => total + subcategory.products.length,
                0,
              );

              return (
                <Accordion
                  key={category.category}
                  defaultExpanded={categoryIndex === 0}
                  disableGutters
                  slotProps={{
                    transition: {
                      unmountOnExit: true,
                    },
                  }}
                  sx={{
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: "12px !important",
                    overflow: "hidden",
                    boxShadow: "none",
                    "&::before": { display: "none" },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      minHeight: 62,
                      bgcolor: "background.paper",
                      "& .MuiAccordionSummary-content": { my: 1.25 },
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={2}
                      sx={{ width: "100%", pr: 1 }}
                    >
                      <Box>
                        <Typography fontWeight={800}>
                          {category.category}
                        </Typography>

                        <Typography variant="caption" color="text.secondary">
                          {category.subcategories.length} subcategor
                          {category.subcategories.length === 1 ? "y" : "ies"}
                        </Typography>
                      </Box>

                      <Chip
                        size="small"
                        label={`${categoryProductCount} products`}
                        sx={{
                          bgcolor: "#EEF5EA",
                          color: brandColors.header,
                          fontWeight: 700,
                        }}
                      />
                    </Stack>
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      p: { xs: 1, md: 1.5 },
                      bgcolor: "#FBFCFA",
                    }}
                  >
                    <Stack spacing={1}>
                      {category.subcategories.map((subcategory) => (
                        <Accordion
                          key={`${category.category}-${subcategory.sub_category}`}
                          disableGutters
                          elevation={0}
                          slotProps={{
                            transition: {
                              unmountOnExit: true,
                            },
                          }}
                          sx={{
                            border: "1px solid",
                            borderColor: "divider",
                            borderRadius: "9px !important",
                            overflow: "hidden",
                            "&::before": { display: "none" },
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon fontSize="small" />}
                            sx={{
                              minHeight: 52,
                              bgcolor: "#F4F8F1",
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                              sx={{ width: "100%", pr: 1 }}
                            >
                              <Typography variant="body2" fontWeight={750}>
                                {subcategory.sub_category}
                              </Typography>

                              <Chip
                                size="small"
                                variant="outlined"
                                label={`${subcategory.products.length} products`}
                              />
                            </Stack>
                          </AccordionSummary>

                          <AccordionDetails
                            sx={{
                              p: { xs: 1, md: 1.5 },
                              bgcolor: "common.white",
                            }}
                          >
                            {isMobile ? (
                              <Stack spacing={1.25}>
                                {subcategory.products.map((product) => (
                                  <MobileProductCard
                                    key={
                                      product.product_id ||
                                      `${product.name}-${product.supplier}`
                                    }
                                    product={product}
                                    onOpenActions={handleOpenActions}
                                    onView={handleImageClick}
                                  />
                                ))}
                              </Stack>
                            ) : (
                              <DesktopProductTable
                                products={subcategory.products}
                                onOpenActions={handleOpenActions}
                                onView={handleImageClick}
                              />
                            )}
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Stack>
        )}
      </Box>

      {/* ===============================================================
          ONE SHARED ACTIONS MENU FOR ALL PRODUCT ROWS
      =============================================================== */}
      <Menu
        anchorEl={actionMenuAnchor}
        open={Boolean(actionMenuAnchor)}
        onClose={handleCloseActions}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          disabled={!actionProduct}
          onClick={() => {
            if (actionProduct) {
              handleImageClick(actionProduct);
            }
            handleCloseActions();
          }}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>View image</ListItemText>
        </MenuItem>

        <MenuItem
          component="label"
          disabled={
            !actionProduct || uploadingProductId === actionProduct.product_id
          }
        >
          <ListItemIcon>
            {uploadingProductId === actionProduct?.product_id ? (
              <CircularProgress size={18} />
            ) : (
              <CloudUploadIcon fontSize="small" />
            )}
          </ListItemIcon>

          <ListItemText>
            {uploadingProductId === actionProduct?.product_id
              ? "Uploading..."
              : "Upload image"}
          </ListItemText>

          <VisuallyHiddenInput
            type="file"
            accept="image/jpeg,image/png,image/webp"
            onChange={(event) => {
              if (actionProduct) {
                void handleFileUpload(event, actionProduct);
              }
              handleCloseActions();
            }}
          />
        </MenuItem>

        <MenuItem
          disabled={!actionProduct}
          onClick={() => {
            if (actionProduct) {
              handleEdit(actionProduct);
            }
            handleCloseActions();
          }}
        >
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit product</ListItemText>
        </MenuItem>

        <Divider />

        <MenuItem
          disabled={!actionProduct || user?.role !== "SuperAdmin"}
          onClick={() => {
            if (actionProduct) {
              void handleDelete(actionProduct);
            }
            handleCloseActions();
          }}
          sx={{ color: "error.main" }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText>Delete product</ListItemText>
        </MenuItem>
      </Menu>

      {/* ===============================================================
          IMAGE PREVIEW DIALOG
      =============================================================== */}
      <Dialog
        open={imageDialogOpen}
        onClose={() => setImageDialogOpen(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxHeight: "88vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pr: 1,
          }}
        >
          <Box>
            <Typography fontWeight={800}>
              {displayValue(selectedProduct?.name, "Product image")}
            </Typography>

            <Typography variant="caption" color="text.secondary">
              Product image preview
            </Typography>
          </Box>

          <IconButton
            aria-label="Close image preview"
            onClick={() => setImageDialogOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Divider />

        <DialogContent
          sx={{
            p: 2,
            display: "grid",
            placeItems: "center",
            bgcolor: "#F7F8F7",
          }}
        >
          {selectedProduct?.image ? (
            <Box
              component="img"
              src={`${PRODUCT_IMAGE_BASE_URL}/${selectedProduct.image}`}
              alt={selectedProduct.name || "Product"}
              decoding="async"
              sx={{
                display: "block",
                width: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
                borderRadius: 2,
              }}
            />
          ) : (
            <Stack alignItems="center" spacing={1} sx={{ py: 7 }}>
              <ImageNotSupportedOutlinedIcon
                color="disabled"
                sx={{ fontSize: 58 }}
              />

              <Typography color="text.secondary">
                No image is available for this product.
              </Typography>
            </Stack>
          )}
        </DialogContent>
      </Dialog>

      {/* ===============================================================
          ADD / EDIT PRODUCT DIALOG
      =============================================================== */}
      <Dialog
        open={productDialogOpen}
        onClose={handleCloseProductDialog}
        fullWidth
        maxWidth="md"
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: { xs: 0, md: 3 },
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h6" fontWeight={800}>
              {selectedProduct?.product_id ? "Edit Product" : "Add Product"}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              Complete the product details below.
            </Typography>
          </Box>

          <IconButton
            aria-label="Close product form"
            onClick={handleCloseProductDialog}
            disabled={saving}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Divider />

        <DialogContent sx={{ pt: 2.5 }}>
          {selectedProduct && (
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  required
                  label="Product Name"
                  fullWidth
                  value={selectedProduct.name ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("name", event.target.value)
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  required
                  label="Description"
                  fullWidth
                  value={selectedProduct.description ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("description", event.target.value)
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  required
                  label="Category"
                  fullWidth
                  value={selectedProduct.category ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("category", event.target.value)
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  required
                  label="Subcategory"
                  fullWidth
                  value={selectedProduct.sub_category ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("sub_category", event.target.value)
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Supplier"
                  fullWidth
                  value={selectedProduct.supplier ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("supplier", event.target.value)
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  required
                  label="Cost"
                  type="number"
                  fullWidth
                  value={selectedProduct.cost ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("cost", event.target.value)
                  }
                  slotProps={{
                    htmlInput: { min: 0, step: "0.01" },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  required
                  label="MSRP"
                  type="number"
                  fullWidth
                  value={selectedProduct.msrp ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("msrp", event.target.value)
                  }
                  slotProps={{
                    htmlInput: { min: 0, step: "0.01" },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  required
                  label="Pre-pack"
                  type="number"
                  fullWidth
                  value={selectedProduct.packed ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("packed", event.target.value)
                  }
                  slotProps={{
                    htmlInput: { min: 0, step: "1" },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  required
                  label="Unit"
                  fullWidth
                  value={selectedProduct.unit ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("unit", event.target.value)
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  label="HST"
                  type="number"
                  fullWidth
                  value={selectedProduct.hst ?? ""}
                  onChange={(event) =>
                    updateSelectedProduct("hst", event.target.value)
                  }
                  slotProps={{
                    htmlInput: { min: 0, step: "0.01" },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={2}
                  sx={{
                    minHeight: 56,
                    px: 1.5,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 1,
                  }}
                >
                  <Typography>Client Visible</Typography>

                  <Select
                    size="small"
                    value={String(selectedProduct.client_visible ?? "true")}
                    onChange={(event) =>
                      updateSelectedProduct(
                        "client_visible",
                        event.target.value,
                      )
                    }
                  >
                    <MenuItem value="true">Yes</MenuItem>
                    <MenuItem value="false">No</MenuItem>
                  </Select>
                </Stack>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={2}
                  sx={{
                    minHeight: 56,
                    px: 1.5,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 1,
                  }}
                >
                  <Typography>Store Visible</Typography>

                  <Select
                    size="small"
                    value={String(selectedProduct.store_visible ?? "true")}
                    onChange={(event) =>
                      updateSelectedProduct("store_visible", event.target.value)
                    }
                  >
                    <MenuItem value="true">Yes</MenuItem>
                    <MenuItem value="false">No</MenuItem>
                  </Select>
                </Stack>
              </Grid>

              {!selectedProduct.product_id && (
                <Grid size={12}>
                  <Button
                    component="label"
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                    disabled={saving}
                  >
                    {uploadedImage
                      ? `Selected: ${uploadedImage.name}`
                      : "Select Product Image"}

                    <VisuallyHiddenInput
                      type="file"
                      accept="image/jpeg,image/png,image/webp"
                      onChange={handleNewProductImageSelection}
                    />
                  </Button>
                </Grid>
              )}
            </Grid>
          )}
        </DialogContent>

        <Divider />

        <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={handleCloseProductDialog}
            disabled={saving}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            disabled={saving || !selectedProduct}
            startIcon={saving ? <CircularProgress size={17} /> : undefined}
            onClick={() => {
              if (selectedProduct) {
                void handleSaveProduct(selectedProduct);
              }
            }}
          >
            {saving ? "Saving..." : "Save Product"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Products;
